let INSET = 0;
export const POSITIONS = {
  'bottom': {
    bottom: INSET,
    left: 0,
    right: 0,
  },
  'top': {
    top: INSET,
    left: 0,
    right: 0,
  },
  'top-right': {
    top: INSET,
    right: INSET,
  },
  'top-left': {
    top: INSET,
    left: INSET,
  },
  'bottom-left': {
    bottom: INSET,
    left: INSET,
  },
  'bottom-right': {
    bottom: INSET,
    right: INSET,
  },
};
